// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 590 ? "app-main" : chunkId) + "-legacy." + {"346":"1712f1e8","590":"c01078e4"}[chunkId] + ".js";
};